<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="objectsTable.additionalFilters"
                                    :default-sort="objectsTable.defaultSort"
                                    :excel="true"
                                    :fields="objectsTable.headers"
                                    :header-selection-key="'maritime-objects-headers'"
                                    :height="objectsTable.height"
                                    :total-records="objectsTable.total"
                                    :filter-save-key="'maritime-objects-filters'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in objectsTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(item.id, true)"
                                    >
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('id')"
                                            class="text-right"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.id }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('imo')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.imo }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('name')"
                                            class="font-weight-bold"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.name }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('vessel_type')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.vessel_type }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('registered_flag')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.registered_flag }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('gt')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.gt }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('engine_type')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.engine_type }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('engine_model')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.engine_model }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('dp_model')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.dp_model }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('dp_manufacturer')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.dp_manufacturer }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('manager')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.manager }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('client')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.client }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('employer')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.employer }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('invoice_to')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.invoice_to }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('internal_office')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.internal_office }}
                                        </td>
                                        <td
                                            v-if="objectsTable.selectedHeaders.includes('active')"
                                            class="text-center"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-icon v-if="item.active" small>fa-check</v-icon>
                                            <v-icon v-else small>fa-minus</v-icon>
                                        </td>
                                        <td class="text-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'MaritimeObjects',
    components: {TheTable},
    data: function () {
        return {
            objectsTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.id'), value: 'id', type: 'string', allowFilter: true, width: '50px'},
                    {text: this.$t('fields.imo'), value: 'imo', type: 'string', allowFilter: true},
                    {text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.vesselType'),
                        value: 'vessel_type',
                        type: 'multiple|vessel-types',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.registeredFlag'),
                        value: 'registered_flag',
                        type: 'multiple|countries',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.gt'), value: 'gt', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.engineType'),
                        value: 'engine_type',
                        type: 'multiple|engine-types',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.engineModel'),
                        value: 'engine_model',
                        type: 'string',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.dpModel'),
                        value: 'dp_model',
                        type: 'multiple|dp-types',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.dpManufacturer'),
                        value: 'dp_manufacturer',
                        type: 'multiple|dp-manufacturers',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.manager'), value: 'manager', type: 'multiple|entities', allowFilter: true},
                    {text: this.$t('fields.client'), value: 'client', type: 'multiple|entities', allowFilter: true},
                    {
                        text: this.$t('fields.employerEntity'),
                        value: 'employer',
                        type: 'multiple|entities',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.invoiceTo'),
                        value: 'invoice_to',
                        type: 'multiple|entities',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.employerOffice'),
                        value: 'internal_office',
                        type: 'multiple|internal-offices',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.active'),
                        value: 'active',
                        type: 'boolean',
                        default: null,
                        width: '140px',
                        allowFilter: true,
                    },
                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'id',
                    descending: true,
                },
            },
        };
    },
    methods: {
        addClick() {
            this.$router.push('/maritime-objects/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/maritime-objects/' + id);
            } else {
                let routeData = this.$router.resolve('/maritime-objects/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.objectsTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'maritime-objects', request, (data, success) => {
                if (success) {
                    vm.objectsTable.items = data.items;
                    vm.objectsTable.total = data.total;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'maritime-objects',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/maritime-objects', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.objectsTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.maritimeObjects'), href: '/#/maritime-objects', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resolveWindowResize);
    },
};
</script>

<style scoped></style>
